import React from 'react';
import styled from 'styled-components';
import { Formik, Field } from 'formik';
import { Grid, Tooltip } from '@inplayer-org/inplayer-ui';
import { MdInfoOutline } from 'react-icons/md';

// utils
import JSONparse from 'utils/json-parse-safe';

// components
import { FullHeightForm, ContentContainer } from 'components/SharedStyledElements';
import Input from 'components/Fields/Input';
import FormAccordionHelper, { SectionType } from '../../components/AccordionHelper';

const { Container, Cell } = Grid;

const StyledTooltip = styled(Tooltip)`
  margin-bottom: 0.5rem;
`;

interface FormValues {
  account_id: string;
  event_id: string;
  video_id: string;
}

const defaultValues: FormValues = {
  account_id: '',
  event_id: '',
  video_id: '',
};

interface Props {
  rawContent: string;
  onSubmit: (contentString: string, externalAssetId: string) => void;
  formId: string;
  isReadOnly: boolean;
  closePanel: () => void;
}

const LiveStreamContent = ({ rawContent, onSubmit, formId, isReadOnly, closePanel }: Props) => {
  const initialValues: FormValues = {
    ...defaultValues,
    ...JSONparse(rawContent).value,
  };

  const handleSubmit = (data: FormValues) => {
    const contentString = JSON.stringify(data);
    const { video_id: externalAssetId } = data;

    onSubmit(contentString, externalAssetId);
  };

  return (
    <Formik onSubmit={handleSubmit} initialValues={initialValues}>
      {() => (
        <FullHeightForm id={formId}>
          <FormAccordionHelper initialValues={initialValues} index={SectionType.Content} closePanel={closePanel} />
          <ContentContainer withPadding>
            <Container columns={1} rowGap="1rem">
              <Cell>
                <Field
                  tag="text_input_account_id"
                  name="account_id"
                  label="Account ID"
                  component={Input}
                  disabled={isReadOnly}
                />
              </Cell>
              <Cell>
                <Field
                  tag="text_input_event_id"
                  name="event_id"
                  label="Event ID"
                  component={Input}
                  disabled={isReadOnly}
                />
              </Cell>
              <Cell>
                <StyledTooltip
                  tag="tooltip_video_id"
                  placement="right"
                  content="This parameter is optional for live events."
                >
                  Video ID <MdInfoOutline />
                </StyledTooltip>
                <Field tag="text_input_video_id" name="video_id" component={Input} disabled={isReadOnly} />
              </Cell>
            </Container>
          </ContentContainer>
        </FullHeightForm>
      )}
    </Formik>
  );
};

export default LiveStreamContent;
